import { CardContent, Chip, Divider, Grid, List, ListItem, ListItemText, Typography } from '@mui/material';
import React, { useEffect } from 'react'
import { NewsService } from '../../Component/Api/News/NewsService';
import { MDTypography } from '../../Component/Common/Components/MDTypography';
import { News } from '../../Component/Model/Dto/News';
import { NewsTypes } from '../../Component/Model/Enum/News';
import Card from '@mui/material/Card';
import { floor } from 'lodash';
import { SkeletonLoading } from '../../Component/Common/SkeletonLoading/SkeletonLoading';
import { SimplePagination } from '../../Component/Common/Pagination/simplePagination';
import { DateFormatter } from '../../Component/Model/helpers';

interface IProps {
  newsType: NewsTypes;
}

export const NewsPage = (props: IProps) => {

  const [newsData, setNewsData] = React.useState<News.Response[]>([]);
  const [itemsPerPage, setItemsPerPage] = React.useState(10);
  const [activePage, setActivePage] = React.useState(1);
  const [isLoading, setIsLoading] = React.useState(false);
  const [countPages, setCountPages] = React.useState(0);

  const indexOfLastNewsPage = activePage * itemsPerPage;
  const indexOfFirstNewsPage = indexOfLastNewsPage - itemsPerPage;

  const currentNewsPage = newsData.slice(
    indexOfFirstNewsPage,
    indexOfLastNewsPage
  );

  const getNews = async () => {
    setIsLoading(true);
    try {
      let response = await NewsService.getNews(props.newsType);
      setNewsData(response.data);
      setCountPages(floor(response.data.length / itemsPerPage, 0));
    }
    catch (error) {
      console.log(error);
    }
    finally {
      setIsLoading(false);
    }
  }

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setActivePage(value);
  };

  useEffect(() => {
    getNews();

  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  const renderNews = currentNewsPage.map((result, index) => {
    return (
      <>
        <ListItem key={`list-item-${index}`} alignItems="flex-start">
          <ListItemText
            primary={
              <Grid container alignItems="center" spacing={1} justifyContent="space-between">
                <Grid item>
                  <Typography variant="h4" component="a" color="primary" href={result.url} target='_blank'>{result.subject}</Typography>
                </Grid>
                <Grid item>
                  {!result.isBEEngaged && <Chip label="BEE" variant="outlined" size='small' color='primary' />}
                  {result.isBEEngaged && <Chip label="BEEngaged" variant="outlined" size='small' color='primary' />}
                </Grid>
              </Grid>
            }
            secondary={
              <React.Fragment>
                <Typography color="secondary" variant='h6'>{DateFormatter(result.date.toString())}</Typography>
                <Typography variant="body2">
                  {result.summary}
                </Typography>
              </React.Fragment>
            }
          />
        </ListItem>
        <Divider variant="inset" component="li" key={`divider-key-${index}`} />
      </>
    );
  });

  const renderContent = () => {
    if (newsData.length > 0) {
      return (
        <>
          {props.newsType === NewsTypes.BEEngaged &&
            <Typography variant="body2">  
              <p>
                BEE123 is a strategic partner for the recently launched BEEngaged Magazine. As such, we are delighted to advise that the BEEngaged Magazine is available to all BEE123 clients for FREE!
                To access the BEEngaged Magazine, please click on the links below and use the provided password:
              </p>        
            </Typography> 
          }
          
          <SimplePagination activePage={activePage} countPages={countPages} handlePageChange={handlePageChange} />
          <Grid container mt={1} mb={1}>
            <Grid item xs={12} >
              <Card>
                <CardContent>
                  <List>{renderNews}</List>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <SimplePagination activePage={activePage} countPages={countPages} handlePageChange={handlePageChange} />
        </>
      )
    }
    else {
      if (isLoading) {
        return <SkeletonLoading formLoading FieldAmount={6} />
      }
      else {
        return (
          <MDTypography>No News to Show</MDTypography>
        )
      }
    }
  }

  return (
    <>
      {renderContent()}
    </>
  )
}
